import script from "./Registration.vue?vue&type=script&setup=true&lang=js"
export * from "./Registration.vue?vue&type=script&setup=true&lang=js"

import "./Registration.vue?vue&type=style&index=0&id=55796824&lang=scss"

const __exports__ = script;

export default __exports__